import React, { Component } from 'react';

const RECAPTCHA_SITE_KEY = process.env.RECAPTCHA_SITE_KEY || '6LfF0ZUlAAAAAE8MfPz-FBWAIC5fIS1g-r-Mjv0T';

export const getCaptchaToken = async (action = 'homepage') => {
	if (!window.captchloaded || !window.grecaptcha) {
		return '';
	}

	const token = await new Promise((resolve) => {
		window.grecaptcha
			.execute(RECAPTCHA_SITE_KEY, { action })
			.then((token) => resolve(token));
	});
	return token;
};

class Recptcha extends Component {
	componentDidMount() {
		const handleLoaded = () => {
			window.grecaptcha.ready(() => {
				window.captchloaded = true;
			});
		};
		// Add reCaptcha
		const script = document.createElement('script');
		script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
		script.addEventListener('load', handleLoaded);
		document.body.appendChild(script);
	}

	render() {
		return (
			<div
				className="g-recaptcha"
				data-sitekey={RECAPTCHA_SITE_KEY}
				data-size="invisible"
			/>
		);
	}
}

export default Recptcha;



// WEBPACK FOOTER //
// ./src/components/ReCaptcha.js